<template>
    <div>
        <label
            :for="id ? id : name"
        >{{label}}</label>
        <input
            :type="type ? type : 'text'"
            ref="input"
            class="form-control"
            :class="validation ? 'is-invalid' : ''"
            :name="name"
            :id="id ? id : name"
            :value="value"
            :autocomplete="autocomplete"

            @input="changeValue()"
        >
        <small class="invalid-feedback font-weight-bold" v-if="validation">
            <span v-for="(el, key) in validation" :key="key">{{el}}</span>
        </small>
    </div>
</template>

<script>
    export default {
        props: ['type', 'name', 'id', 'value', 'label' , 'invalid','autocomplete'],
        data() {
            return {
                val: null,
                validation: null,
            }
        },
        methods: {
            changeValue(ev) {
                this.$emit('input', this.$refs.input.value);

                this.validation = null
            }
        },
        watch: {
            invalid(val){
                this.validation  = val;
            }
        }
    }
</script>
